import Theme, {applyTheme} from '@jetbrains/ring-ui-built/components/global/theme'

import {getCurrentTheme} from '../selectors/getCurrentTheme'
import * as darkThemeAdapter from '../services/theme'
import {iframeManager} from '../services/theme'
import store from '../store'
import {isDarkThemeAdapterEnabled} from '../utils/featureToggles'

const adaptDarkTheme = (theme: Theme.DARK | Theme.LIGHT) => {
  if (!isDarkThemeAdapterEnabled) {
    return
  }

  switch (theme) {
    case Theme.DARK:
      darkThemeAdapter.enable()
      break
    case Theme.LIGHT:
    default:
      darkThemeAdapter.disable()
      break
  }
}

const setTheme = (theme: Theme.DARK | Theme.LIGHT): void => {
  adaptDarkTheme(theme)
  applyTheme(theme, document.documentElement)
  iframeManager.sendChangeThemeRequest(theme)
}

export const trackGlobalTheme = () => {
  let prevTheme: Theme
  let unsubscribe: (() => void) | undefined
  const storeHandler = () => {
    const theme = getCurrentTheme(store.getState())
    if (theme !== prevTheme) {
      prevTheme = theme
      if (theme === Theme.AUTO) {
        const darkMatcher = window.matchMedia('(prefers-color-scheme: dark)')
        const handler = () => setTheme(darkMatcher.matches ? Theme.DARK : Theme.LIGHT)
        handler()
        darkMatcher.addEventListener('change', handler)
        unsubscribe = () => {
          darkMatcher.removeEventListener('change', handler)
        }
      } else {
        unsubscribe?.()
        setTheme(theme)
      }
    }
  }
  storeHandler()
  store.subscribe(storeHandler)
}
